import { Flex, Grid, Text, Divider, Button, Spinner, useToast, Icon } from '@chakra-ui/react'
import Header from '../../../components/Header'
import { DatetimeLocal } from './components/DatetimeLocal'
import { Card } from './components/Card'
import { Layout } from './Layout'
import { useForm } from 'react-hook-form'
import { CardItem } from './components/CardItem'
import { Cubagem } from './components/Cubagem'
import { useRef, useState } from 'react'
import { useKanguCargobr } from '../../../contexts/KanguCargobrContext'
import { useEffect } from 'react'
import { Transportadora } from './components/Transportadora'
import { formatPrice } from '../../../utils/formatPrice'
import InputFloating from '../../../components/InputFloating'
import { api } from '../../../services/api'
import { Box } from '@chakra-ui/layout'
import { CloseIcon } from '@chakra-ui/icons'
import { getShippingKangu } from './functions/kangu'
import { getShippingFedex } from './functions/fedex'
import { getShippingJamef } from './functions/jamef'
import { Loader } from './components/Loader'
import { FaShippingFast } from 'react-icons/fa'
import { valoresKangu } from './helpers/valoresKangu'
import { obterValorMaisProximo } from './functions/obterValorMaisProximo'
import { AlertTranspCode } from './AlertTranspCode'
import { ToastSuccess } from './ToastSuccess'
import { AlertTnt } from './AlertTnt'
import { ModalAutorizacao } from './ModalAutorizacao'

// import loader from ''

export function SimulacaoFrete() {
  const {
    reset,
    register,
    handleSubmit,
    control,
    formState: { isSubmitting },
  } = useForm()
  const { dataItems, dataEnterprise, cubagensJamef, getInfoEnterprise, getInfoItems, cubagens, handleAllCubagens, selectAll, setSelectAll, summary } =
    useKanguCargobr()
  const [shippingKangu, setShippingKangu] = useState([])
  const [shippingJamef, setShippingJamef] = useState([])
  const [shippingBuslog, setShippingBuslog] = useState([])
  const [shippingFedex, setShippingFedex] = useState([])
  const [frete, setFrete] = useState(0)
  const [params, setParams] = useState({})
  const [loadingCotations, setLoadingCotations] = useState(false)
  const [loadingCalculateShipping, setLoadingCalculateShipping] = useState(false)
  const [transportadoraCotada, setTransportadoraCotada] = useState({})
  const [cotations, setCotations] = useState(false)
  const [isAgrupped, setIsAgrupped] = useState(false)
  const [infoAgrupped, setInfoAgrupped] = useState({})
  const [proximaCaixa, setProximaCaixa] = useState({})
  const [itemCotado, setItemCotado] = useState(false)
  const [buttonPosition, setButtonPosition] = useState('')
  const [transpCodeOpen, setTranspCodeOpen] = useState(false)
  const [transpCode, setTranspCode] = useState('')
  const [alertTntOpen, setAlertTntOpen] = useState({
    isOpen: false,
    message: '',
  })

  const toast = useToast()

  const totalCaixas = dataItems?.reduce((acc, curr) => {
    const { quantidade_caixas } = curr

    const quantidadeCaixas = parseInt(quantidade_caixas) || 0

    return acc + quantidadeCaixas
  }, 0)

  const resumoPedido = cubagens?.reduce(
    (acc, curr) => {
      const { vlr_total, sub_tributaria } = curr

      const vlrTotal = acc.vlrTotal + parseFloat(vlr_total) || 0
      const subTributaria = acc.subTributaria + parseFloat(sub_tributaria) || 0

      return {
        vlrTotal,
        subTributaria,
      }
    },
    {
      vlrTotal: 0,
      subTributaria: 0,
    }
  )

  function handleParams(data) {
    setParams(data)
  }

  async function getTransportadoraCotada(data) {
    const response = await api.get(`site/v2/editar-pedido/listar-informacoes-transp/${data.numero_nota}`)

    if (response.data) {
      setTransportadoraCotada(response.data)
    } else {
      setTransportadoraCotada({})
    }
  }

  async function onSubmit(data) {
    try {
      await getInfoEnterprise(data)
      await getInfoItems(data)
    } catch (error) {
      toast({
        title: 'Erro ao buscar dados do pedido',
        description: 'Verifique o cadastro de endereço do pedido',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      })
    }

    await getTransportadoraCotada(data)
    reset()
  }

  // const verificaKangu = parseFloat(dataItems[0]?.calc_kangu.replace(',', '.'))

  const verificaKangu = cubagens?.reduce((acc, curr) => {
    const { calc_kangu } = curr

    const calcKangu = parseFloat(calc_kangu.replace(',', '.')) || 0

    return acc + calcKangu
  }, 0)

  const refCotationsTable = useRef()

  const qtdCaixas = cubagens?.reduce((acc, curr) => {
    const { quantidade_caixas } = curr
    const qtdCaixas = parseInt(quantidade_caixas) || 0

    return acc + qtdCaixas
  }, 0)

  function handleKangu() {
    const verificacao = verificaKangu * qtdCaixas < 20 ? true : false //menor que 20 quando chegar a caixa 60

    const itensAgrupados = cubagens.filter((item) => {
      if (verificacao) {
        return item
      }
    })

    const kanguValue = itensAgrupados.reduce((acc, curr) => {
      const { calc_kangu, cubagensKangu } = curr
      const calcKanguReplace = parseFloat(calc_kangu.replace(',', '.')) || 0
      const quantidadeCaixa = parseInt(cubagensKangu.quantidade_caixas) || 0

      return acc + calcKanguReplace * quantidadeCaixa
    }, 0)

    const valorMaisProximo = obterValorMaisProximo(valoresKangu, kanguValue)

    const infoItensAgrupados = itensAgrupados.reduce(
      (acc, curr) => {
        const { quantidade_caixas, peso_total } = curr

        const qtdCaixas = parseInt(quantidade_caixas) || 0
        const pesoTotal = parseFloat(peso_total) || 0

        const pesoTotalAgrupado = acc.pesoTotalAgrupado + pesoTotal
        const qtdCaixasAgrupado = acc.qtdCaixasAgrupado + qtdCaixas

        return {
          pesoTotalAgrupado,
          qtdCaixasAgrupado,
        }
      },
      {
        pesoTotalAgrupado: 0,
        qtdCaixasAgrupado: 0,
      }
    )

    const cubagenKangu = cubagens?.map((item) => {
      return item.cubagensKangu
    })

    const proxCaixa = cubagenKangu?.reduce((acc, item) => {
      const { pesoCaixa } = item

      const pesoTotal = parseFloat(pesoCaixa) || 0

      return acc + pesoTotal
    }, 0)

    const parametroProximaCaixa = {
      peso: proxCaixa,
      altura: valorMaisProximo?.altura,
      largura: valorMaisProximo?.largura,
      comprimento: valorMaisProximo?.comprimento,
      value: valorMaisProximo?.value,
    }

    setInfoAgrupped(infoItensAgrupados)

    setProximaCaixa(parametroProximaCaixa)

    if (verificacao && qtdCaixas > 1 && valorMaisProximo) {
      setIsAgrupped(true)
    } else {
      setIsAgrupped(false)
    }

    return verificacao
  }

  useEffect(() => {
    setFrete(0)
    setShippingKangu([])
    setShippingJamef([])
    setShippingBuslog([])
    setShippingFedex([])
    setSelectAll(false)
  }, [dataItems, dataEnterprise])

  useEffect(() => {
    const data = {
      numero_nota: dataEnterprise?.numero_nota,
    }

    getTransportadoraCotada(data)
    return () => setCotations(false)
  }, [cotations])

  function scrollToCotations() {
    const element = refCotationsTable.current
    element.scrollIntoView({ behavior: 'smooth' })
  }

  console.log(params)

  async function getAllTransportadoras() {
    if (resumoPedido.vlrTotal === 0) {
      toast({
        title: 'Erro ao calcular frete',
        description: 'Valor total dos itens não pode ser 0, atualize o pedido',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      })
      return
    }

    setLoadingCalculateShipping(true)
    const isKangu = handleKangu()

    if (cubagens.length !== 0) {
      const requests = []

      if (isKangu) {
        requests.push(getShippingKangu(cubagens, dataEnterprise, totalCaixas, proximaCaixa, isAgrupped))
      }

      // Removendo a chamada para o Melhor Envio
      // requests.push(getShippingMelhorEnvio(cubagens, dataEnterprise.ent_cep))

      // Outras transportadoras
      requests.push(getShippingFedex(cubagens, dataEnterprise, resumoPedido, totalCaixas, isAgrupped, proximaCaixa))

      try {
        const responses = await Promise.all(requests)

        // Ajustar índices conforme as requisições
        const startIndex = isKangu ? 1 : 0

        // const responseMelhorEnvio = responses[startIndex]
        const responseTNT = responses[startIndex]

        if (responseTNT[0]?.Transportadora) {
          setAlertTntOpen({
            isOpen: true,
            message: responseTNT[0]?.Erro[0],
          })
        }

        if (isKangu) {
          setShippingKangu(responses[0])
        } else {
          setShippingKangu([])
        }

        // Não estamos mais usando o Melhor Envio
        // setShippingBuslog(responseMelhorEnvio)
        setShippingFedex(responses[startIndex])

        //evitar que duplique o toast
        toast.closeAll()
        toast({
          duration: 7000,
          isClosable: true,
          position: 'top-right',
          render: () => (
            <Box color="white" p={3} bg="#95C620">
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontWeight="bold">Cotações realizadas com sucesso</Text>
                <CloseIcon onClick={() => toast.closeAll()} cursor="pointer" />
              </Flex>
              <Text>Desça a página para visualizar as cotações ou clique em "Ver cotações"</Text>
              <Button
                mt=".3rem"
                onClick={() => scrollToCotations()}
                bgColor="#95C620"
                filter="brightness(0.9)"
                _hover={{
                  filter: 'brightness(0.8)',
                }}
              >
                Ver cotações
              </Button>
            </Box>
          ),
        })

        setItemCotado(true)
      } catch (error) {
        toast({
          title: 'Erro ao calcular frete',
          description: error?.mensagem || 'Tente novamente mais tarde',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        })
      }
    }

    setLoadingCalculateShipping(false)
  }

  console.log('enter', dataEnterprise.liberacao_pedido)

  const [openModalAutorizacao, setOpenModalAutorizacao] = useState(false)

  async function saveCotations({ transpCode }) {
    if (
      params?.preco !== 0 &&
      params.nome !== 'Cliente Retira' &&
      params.nome !== 'Transportadora Cliente' &&
      dataEnterprise.liberacao_pedido === 'N'
    ) {
      setOpenModalAutorizacao(true)
      return
    }

    const paramsForSave = cubagens?.map((item) => {
      return {
        numero_nota: dataEnterprise?.numero_nota,
        codigo_produto: item?.codigo,
        quantidade_caixas: item?.quantidade_caixas,
        quantidade_pecas_caixa: item?.quantidade_pecas,
        medida_caixa: item?.medida,
        peso_por_caixa: item?.peso_caixa,
        peso_total: item?.peso_total,
        nome_produto: item?.nome,
        peso_total_itens: summary?.pesoTotal,
        peso_caixas_itens: summary?.quantidadeTotal,
        transportadora: params?.nome_transp,
        nunota: dataEnterprise?.numero_nota,
        valor_total_pedido: resumoPedido?.vlrTotal,
        cep_numero: dataEnterprise?.ent_cep,
      }
    })

    const paramsTransp = {
      dados: paramsForSave,
    }

    const pesoTot = cubagens?.reduce((acc, item) => {
      const { peso_total } = item

      const pesoTotal = parseFloat(peso_total) || 0

      return acc + pesoTotal
    }, 0)

    const qtdCaixaTot = cubagens?.reduce((acc, item) => {
      const { quantidade_caixas } = item

      const qtdCaixa = parseFloat(quantidade_caixas) || 0

      return acc + qtdCaixa
    }, 0)

    if (params.tipo_transportadora === 'TC') {
      setTranspCodeOpen(true)
      if (transpCode === undefined || transpCode === '') {
        return
      }
      const newParams = {
        ...params,
        cod_transp: transpCode,
        transpCode: transpCode,
        peso: pesoTot,
      }

      try {
        const response = await api.post('/site/v2/pedido/atualiza-transportadora-responsavel', newParams)

        toast({
          render: () => <ToastSuccess params={params} toast={toast} />,
          isClosable: true,
          duration: 10000,
          position: 'top',
        })
      } catch (error) {
        toast({
          title: 'Erro ao salvar cotação!',
          position: 'top-right',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      }

      return
    }

    try {
      const urlCondition = params?.isJamef
        ? '/site/v2/simula-jamef/armazena-simulacao-jamef'
        : params?.isKangu
          ? '/site/v2/frete-transp-kangu/armazena-frete-kangu'
          : params?.isBuslog
            ? '/site/v2/simulacao-buslog/armazena-simulacao-buslog'
            : params?.isFedex
              ? '/site/v2/simula-fedex/armazena-simulacao-fedex'
              : params?.isIntern && params?.tipo_transportadora !== 'J3'
                ? '/site/v2/pedido/atualiza-transportadora-responsavel'
                : params?.isIntern && params?.tipo_transportadora === 'J3'
                  ? '/site/v2/tracken/armazena-simulacao-tracken'
                  : ''

      const peso = pesoTot

      const newParams = {
        ...params,
        quantidade_caixa: qtdCaixaTot,
        peso: peso,
        agrupado: isAgrupped ? proximaCaixa : null,
      }

      setLoadingCotations(true)
      const response = await api.post(urlCondition, newParams)

      const saveDataTransp = await api.post('/site/v2/crm-controle/inserir-dados-transportadora', paramsTransp)

      setLoadingCotations(false)

      toast({
        render: () => <ToastSuccess params={params} toast={toast} />,
        isClosable: true,
        duration: 10000,
        position: 'top',
      })
    } catch (error) {
      setLoadingCotations(false)
      toast({
        title: 'Erro ao salvar cotação!',
        position: 'top-right',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    } finally {
      setLoadingCotations(false)
    }

    setCotations(true)
  }

  function selectAllCotations() {
    handleAllCubagens()
  }

  function verifyButtonPositionOnScroll() {
    const scrollPosition = window.scrollY

    if (scrollPosition > 500) {
      setButtonPosition('fixed')
    } else {
      setButtonPosition('relative')
    }
  }

  useEffect(() => {
    verifyButtonPositionOnScroll()
    window.addEventListener('scroll', verifyButtonPositionOnScroll)
    return () => {
      window.removeEventListener('scroll', verifyButtonPositionOnScroll)
    }
  }, [])

  return (
    <>
      {loadingCalculateShipping && <Loader />}
      <AlertTranspCode isOpen={transpCodeOpen} onClose={() => setTranspCodeOpen(false)} saveCotations={saveCotations} />

      <ModalAutorizacao
        isOpen={openModalAutorizacao}
        onClose={() => setOpenModalAutorizacao(false)}
        numero_pedido={dataEnterprise?.numero_unico}
        refresh={() => getInfoEnterprise({ numero_nota: dataEnterprise?.numero_nota })}
      />

      <AlertTnt isOpen={alertTntOpen.isOpen} onClose={() => setAlertTntOpen(false)} error={alertTntOpen.message} />

      <Flex
        marginBlock={'1rem'}
        maxW={'500px'}
        w={'100%'}
        mx={'auto'}
        justifyContent={'space-between'}
        alignItems={'center'}
        as="form"
        onSubmit={handleSubmit(onSubmit)}
      >
        <InputFloating label="Nº Único" border={'#95C620'} {...register('numero_nota')} />
        <Button
          ml="1rem"
          bgColor={'#95C620'}
          color={'#fff'}
          _hover={{ bgColor: '#95C620', filter: 'brightness(0.9)' }}
          type="submit"
          isLoading={isSubmitting}
        >
          Buscar
        </Button>
      </Flex>
      {isSubmitting && (
        <Flex justifyContent="center" alignItems="flex-start" mt={'4rem'} height="100vh">
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#95C620" size="xl" />
        </Flex>
      )}
      {!isSubmitting && dataItems.length > 0 && (
        <Layout>
          <Grid templateColumns="2fr 1.007fr">
            <DatetimeLocal />
            <Text as="h1" m="0" fontSize="1.3rem" fontWeight="bold" textAlign="center">
              Pedido #{dataEnterprise?.numero_nota}/{dataEnterprise?.numero_unico}
            </Text>
          </Grid>
          <Grid templateColumns="repeat(3, 1fr)" mt="1rem" gap={2}>
            <Card
              title="Dados do faturamento"
              razaosocial={dataEnterprise?.fat_razao_social}
              cnpj={dataEnterprise?.fat_cpf_cnpj}
              ie={dataEnterprise?.fat_inscricao}
              endereco={dataEnterprise?.fat_endereco}
              cep={dataEnterprise?.fat_cep}
              cidade={dataEnterprise?.fat_cidade}
              uf={dataEnterprise?.fat_uf}
            />
            <Card
              title="Dados da entrega"
              razaosocial={dataEnterprise?.valida_endereco === 'S' ? dataEnterprise?.fat_razao_social : dataEnterprise?.ent_razao_social}
              cnpj={dataEnterprise?.valida_endereco === 'S' ? dataEnterprise?.fat_cpf_cnpj : dataEnterprise?.ent_cpf_cnpj}
              ie={dataEnterprise?.valida_endereco === 'S' ? dataEnterprise?.fat_inscricao : dataEnterprise?.ent_inscricao}
              endereco={dataEnterprise?.valida_endereco === 'S' ? dataEnterprise?.fat_endereco : dataEnterprise?.ent_endereco}
              cep={dataEnterprise?.valida_endereco === 'S' ? dataEnterprise?.fat_cep : dataEnterprise?.ent_cep}
              cidade={dataEnterprise?.valida_endereco === 'S' ? dataEnterprise?.fat_cidade : dataEnterprise?.ent_cidade}
              uf={dataEnterprise?.valida_endereco === 'S' ? dataEnterprise?.fat_uf : dataEnterprise?.ent_uf}
            />
            {transportadoraCotada?.length !== 0 && (
              <Card
                title="Transportadora escolhida"
                razaosocial={transportadoraCotada[0]?.transportadora}
                prazo={transportadoraCotada[0]?.prazo}
                valor={transportadoraCotada[0]?.valor_simulacao === '0.0' ? 'Grátis' : formatPrice(transportadoraCotada[0]?.valor_simulacao)}
              />
            )}
          </Grid>
          <Flex w="100%" flexDir="column" mt="1rem" gap={3}>
            <Flex alignSelf="end" gap={2}>
              <Button onClick={() => selectAllCotations()} variant="outline" alignSelf="end">
                {!selectAll ? 'Selecionar todos' : 'Desmarcar todos'}
              </Button>
              <Button
                onClick={() => getAllTransportadoras()}
                variant="outline"
                isDisabled={cubagens.length === 0}
                boxShadow="0 0 10px rgba(0,0,0,.2)"
                bgColor="#95c620"
                color="white"
                bottom={buttonPosition === 'fixed' ? '1rem' : '0'}
                right={buttonPosition === 'fixed' ? '1rem' : '0'}
                transition="all .3s ease"
                h={10}
                _hover={{
                  filter: 'brightness(0.9)',
                }}
                position={buttonPosition}
                zIndex="999"
              >
                Calcular
              </Button>
            </Flex>

            {dataItems.map((item, index) => (
              <CardItem key={index} index={index} item={item} control={control} setItemCotado={setItemCotado} />
            ))}
          </Flex>
          <Cubagem isAgrupped={isAgrupped} infoAgrupped={infoAgrupped} proximaCaixa={proximaCaixa} />
          <Text as="h1" m="0" fontSize="1rem" textTransform="uppercase" textAlign="center" bg="#95c620" paddingBlock=".6rem" mt="1rem" color="#fff">
            Frete
          </Text>
          {!loadingCalculateShipping && (
            <Box ref={refCotationsTable}>
              <Transportadora
                shipping={shippingJamef}
                shippingKangu={shippingKangu}
                shippingBuslog={shippingBuslog}
                shippingFedex={shippingFedex}
                setFrete={setFrete}
                handleParams={handleParams}
                params={params}
                isFreteGratis={dataEnterprise?.frete_gratis === 'S'}
                isSp={dataEnterprise?.valida_frete === 'S'}
                isCapital={dataEnterprise?.frete_capital === 'S'}
                numeroNota={dataEnterprise?.numero_nota}
                quantidadeCaixas={totalCaixas}
                itemCotado={itemCotado}
                resumoPedido={resumoPedido}
                handleKangu={handleKangu}
                transpCode={transpCode}
              />
            </Box>
          )}
          {loadingCalculateShipping && (
            <Flex justifyContent="center" alignItems="flex-start" mt={'4rem'} height="100px">
              <Icon as={FaShippingFast} fontSize="4rem" color="#95C620" />
            </Flex>
          )}

          <Grid templateColumns={'3fr 1fr'} mt={'30px'} gap="27px" textTransform="uppercase" fontSize="15px">
            <Grid templateColumns="1fr .2fr 1fr .2fr .8fr" paddingBlock={'15px'} border="1px solid #CFCFCF" placeItems={'center'}>
              <Text>Valor total dos Itens: {formatPrice(resumoPedido.vlrTotal)} </Text>
              <Divider orientation="vertical" />
              <Text>Substituição tributária: {formatPrice(cubagens[0]?.sub_tributaria)}</Text>

              <Divider orientation="vertical" />
              <Text>Valor do frete: {formatPrice(frete)}</Text>
            </Grid>
            <Grid placeItems={'center'} paddingBlock={'15px'} bgColor="#414042" color={'white'}>
              <Text>
                Valor total do pedido:{' '}
                <Text as={'span'} fontWeight={'bold'}>
                  {formatPrice(parseFloat(resumoPedido.vlrTotal) + parseFloat(frete) + parseFloat(cubagens[0]?.sub_tributaria))}
                </Text>
              </Text>
            </Grid>
          </Grid>
          <Button
            mt={'1rem'}
            bgColor={'#95C620'}
            color={'#fff'}
            _hover={{ bgColor: '#95C620', filter: 'brightness(0.9)' }}
            alignSelf={'center'}
            onClick={saveCotations}
            isDisabled={Object.keys(params).length === 0}
            isLoading={loadingCotations}
          >
            Salvar cotação
          </Button>
        </Layout>
      )}
    </>
  )
}
